<template>
  <div class="split-pane-page-wrapper">
    <split-pane v-model="offset" ref="splitWidth" @on-move-end="onVehicleInfoSplitMoveEnd">
      <div slot="right" class="pane right-pane">
        <!--    <split-pane v-model="subscribeOffsetVertical" mode="vertical" @on-move-end="onVehicleInfoSplitMoveEnd"-->
        <!--                ref="subscribeSplitV">-->
        <div slot="top" class="pane top-pane" style="overflow: hidden;">
          <vehicle-info-group-tree ref="vehicleinfogrouptree"
                                   @onLoadDirectlyUnderBindVehicleInfos="onLoadDirectlyUnderBindVehicleInfos"
                                   @onLoadAllVehicleInfos="onLoadAllVehicleInfos" @clearBigDataTable="clearBigDataTable"
                                   @onLoadVehicleInfosByGroupId="onLoadVehicleInfosByGroupId" @onvehicleinfo="onvehicleinfo"
                                   :vehicleDymaicManager="vehicleDymaicManager"></vehicle-info-group-tree>
        </div>
        <!--     <div slot="bottom" class="pane bottom-pane" style="overflow: hidden; background-color: #FFFFFF;">-->
        <!--      <vehicle-info-list-->
        <!--       :vehicleListTableHeight="vehicleListTableHeight"-->
        <!--       :vehicleListLoadding="vehicleListLoadding"-->
        <!--       :vehicleListData="vehicleListData"-->
        <!--       @onLoadVehicleDymaicClick="onLoadVehicleDymaicClick"-->
        <!--       @onSingleLoadVehicleDymaicClick="onSingleLoadVehicleDymaicClick"-->
        <!--      ></vehicle-info-list>-->
        <!--     </div>-->
        <!--    </split-pane>-->
      </div>
      <div slot="left" class="pane left-pane">
        <split-pane v-model="offsetVertical" mode="vertical" @on-move-end="onVehicleInfoSplitMoveEnd" ref="splitV">
          <div slot="top" class="pane top-pane" style="overflow: hidden;">
            <arcgis-monitor-map ref="arcgisMonitorMapRef"
                                @onCurrentClickedVehicleInfoChange="onCurrentClickedVehicleInfoChange" :onwarn="onwarn"
                                :vehicleDymaicManager="vehicleDymaicManager"></arcgis-monitor-map>
            <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="mapLoadding">
              <Spin size="large"></Spin>
              <h6 style="color:#2d8cf0;margin-top:10px;">正在加载轨迹数据...</h6>
            </div>

          </div>
          <div slot="bottom" class="pane bottom-pane" ref="vehicleInfoSplit" style="overflow: hidden;">
            <vehicle-dymaic-info-table :alarmCount="alarmCount" :runCount="runCount" :stopCount="stopCount"
                                       :allCount="allCount" style="margin-top: 5px"
                                       ref="vehicleDymaicInfoTableRef" :tableHeight="vehicleDymaicInfoTableHeight"
                                       @onVehicleNameClick="onVehicleNameClick" :onMinimum="onMinimum"
                                       :onMaximize="onMaximize" :onOriginalState="onOriginalState"
                                       :onDownloadTable="onDownloadTable"
                                       @onUnsubscribeAllClick="onUnsubscribeAllClick"
                                       @showwarn="showwarn"
                                       @onSwitchingPath="onSwitchingPath"></vehicle-dymaic-info-table>
          </div>
          <!--     <div slot="trigger" class="custom-trigger">-->
          <!--      <icons class="trigger-icon" :size="22" type="resize-vertical" color="#fff"/>-->
          <!--     </div>-->
        </split-pane>
      </div>
    </split-pane>
  </div>

</template>

<script>

  import ArcgisMonitorMap from '@/view/ddm/components/arcgis-monitor-map'
  import VehicleDymaicInfoTable from '@/view/ddm/components/vehicle-dymaic-info-table'
  import VehicleInfoGroupTree from '@/view/ddm/components/vehicle-info-group-tree'
  import VehicleInfoList from '@/view/ddm/components/vehicle-info-list'

  import Vue from 'vue'
  import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
  import { GPS } from '@/libs/positonUtils'
  import SplitPane from '_c/split-pane'
  import Icons from '_c/icons'
  import store from '@/store'
  import { VehicleDymaicManager } from '@/libs/vehicle-dymaic-manager2'
  import jcicp from '@/proto/jcicp.js'
  import { jcicpEncode, jcicpDecode } from '@/libs/jcicputil.js'
  import { registrationTextColor, registrationColor } from '@/libs/registrationutil'
  import { isAccOn, explainDirection, explainState, explainAlarmSign } from '@/libs/jt808util'
  import { stringToByte } from '@/libs/stringutil'

  // 导出excel
  // import Blob from '../excel/Blob'

  // const { export_json_to_excel } = require('../excel/Export2Excel')

  // 车辆选择订阅列表由服务器数据生成新实体避免重复引用报错
  // DataItem
  //        |---registrationNum
  //        |---registrationColor
  //        |---terminalNum
  //        |---id
  //        |---vin
  //        |---customName
  //        |---customChecked

  export default {
    name: 'realtimemonitorbarcgis',
    components: {
      VehicleDymaicInfoTable,
      VehicleInfoGroupTree,
      ArcgisMonitorMap,
      VehicleInfoList,
      SplitPane,
      Icons
    },
    data () {
      return {
        lastvehicleInfo: null,

        // vehicleDymaicManager数据结构容器 -----------------------------
        // subscribedVehicleInfos:[],  // 已订阅车辆信息列表
        // vehicleInfoHashMap:{},      // 车辆信息哈斯表({key:terminalNum, value:VehicleInfo})
        mapLoadding: false,
        vehicleDymaicInfoTableHeight: 500,

        // 地图元素 --------------------------------
        refreshTaskTimer: null,

        // 选择订阅车辆列表
        readySubscribeList: [],
        // vehicleListTableHeight: 600,
        vehicleListLoadding: false,
        vehicleListData: [],

        // 配置参数 ------------------------------------
        webconfig: {
          id: null,
          realtimeAnalyzePosition: false,
          autoLoadTracks: false,
          autoLoadTracksSpan: 180,
          displayRegistration: true
        },
        debugInfo: {
          loadTrackPointCount: 0
        },

        vehicleDymaicManager: null,

        mapInitZoom: false,

        offset: 0.5,
        offsetVertical: 0.85,
        lastoffsetVertical: 0.75,
        subscribeOffsetVertical: 0.3,

        mapDefaultCenter: null,

        onwarn: true
      }
    },
    methods: {
      showwarn () {
        if (this.onwarn) {
          // console.log('隐藏')
          this.onwarn = false
          this.$refs.arcgisMonitorMapRef.showwarn(this.vehicleDymaicManager.subscribedVehicleInfos, this.onwarn)
        } else {
          // console.log('显示')
          this.onwarn = true
          this.$refs.arcgisMonitorMapRef.showwarn(this.vehicleDymaicManager.subscribedVehicleInfos, this.onwarn)
        }
      },
      /** --------------------------------------------------
       * 方法部分
       */

      makeSelectTableDataItem (servDataList) {
        // 不能直接使用服务端的数据渲染table,后续订阅会导致循环引用json str化出错
        let list = []
        if (!servDataList) {
          return list
        }
        servDataList.forEach(v => {
          let terminalNum = null
          if (v.positioningDeviceInfos && v.positioningDeviceInfos[0]) {
            terminalNum = v.positioningDeviceInfos[0].terminalNum
          }
          let displayName = ''
          if (v.customName) {
            displayName = '(' + v.customName + ')'
          }
          if (v.registrationNum) {
            displayName = displayName + v.registrationNum
          } else {
            displayName = displayName + '车架号:' + v.vin
          }

          let autoChecked = false
          if (this.vehicleDymaicManager.subscribedVehicleInfos) {
            let subscribedVehicleInfosLength = this.vehicleDymaicManager.subscribedVehicleInfos.length
            for (let i = 0; i < subscribedVehicleInfosLength; i++) {
              if (this.vehicleDymaicManager.subscribedVehicleInfos[i].id == v.id) {
                autoChecked = true
                break
              }
            }
          }

          let item = {
            registrationColor: v.registrationColor,
            registrationNum: v.registrationNum,
            vin: v.vin,
            customName: v.customName,
            id: v.id,
            terminalNum: terminalNum,
            displayName: displayName,
            customChecked: autoChecked
          }
          list.push(item)
        })
        return list
      },

      /**
       * 页面分隔变更回调函数
       */
      onVehicleInfoSplitMoveEnd () {
        // console.log(this.$refs.subscribeSplitV.$slots.bottom[0].elm.clientHeight)
        // console.log(this.$refs.splitV.$slots.bottom[0].elm.clientHeight - 30)

        // this.treeStyle.height = (this.$refs.splitWidth.$slots.right[0].elm.clientHeight - 55) + 'px'

        // 调整选择订阅列表
        //   this.vehicleListTableHeight = this.$refs.subscribeSplitV.$slots.bottom[0].elm.clientHeight - 65
        // console.log(this.$refs.vehicleListTable)

        // 调整实时数据列表
        this.vehicleDymaicInfoTableHeight = (this.$refs.splitV.$slots.bottom[0].elm.clientHeight - 30)
        // this.$refs.table.$el.style.height = (this.$refs.splitV.$slots.bottom[0].elm.clientHeight - 30) + 'px'
      },

      /**
       * 反选
       */
      onUnSelectAllClick () {
        let items = this.vehicleListDataMethod()
        if (!items) {
          return
        }
        items.forEach(item => {
          item.customChecked = false
        })
      },

      /**
       * 全选
       */
      onSelectAllClick () {
        let items = this.vehicleListDataMethod()
        if (!items) {
          return
        }
        items.forEach(item => {
          item.customChecked = true
        })
      },

      /**
       * 加载按钮回调函数
       */
      onLoadVehicleDymaicClick (selectItems) {
        console.log('加载按钮回调函数1')
        console.log(selectItems)
        this.readySubscribeList = []
        selectItems.forEach(item => {
          if (item.terminalNum) {
            let v = this.vehicleDymaicManager.findVehicleInfoByTerminalNum(item.terminalNum)
            if (v) {
              this.readySubscribeList.push(v)
            }
          }
        })
        this.vehicleDymaicManager.subscribeDymaicData(this.readySubscribeList, true)
        this.saveRealtimeMonitorSubscribe()
      },

      /**
       * 清除轨迹线
       */
      onSwitchingPath () {
        // 车辆列表
        // this.vehicleDymaicManager.subscribedVehicleInfos
        // console.log(this.vehicleDymaicManager.subscribedVehicleInfos)
        this.$refs.arcgisMonitorMapRef.onvehicletracksLayer(this.vehicleDymaicManager.subscribedVehicleInfos)
      },
      clearBigDataTable () {
        this.$refs.vehicleDymaicInfoTableRef.clearBigData()
      },

      /**
       * 取消监控所有车辆按钮回调函数
       */
      onUnsubscribeAllClick () {
        this.vehicleDymaicManager.cancelSubscribeVehicles(this.vehicleDymaicManager.subscribedVehicleInfos)
        this.$refs.vehicleinfogrouptree.clearCheckedNodes()
        this.saveRealtimeMonitorSubscribe()
      },

      /**
       * 加载单台按钮回调函数
       */
      onSingleLoadVehicleDymaicClick (item) {
        let v = this.vehicleDymaicManager.findVehicleInfoByTerminalNum(item.terminalNum)
        if (v) {
          if (!v.dymaic.realtimeLocationFrame) {
            // 未订阅的订阅
            this.vehicleDymaicManager.subscribeDymaicData([v], true)
          } else {
            // 已有定位数据的跳转到车辆
            this.$refs.arcgisMonitorMapRef.onCloseVehicleInfoWindow()
            this.$refs.arcgisMonitorMapRef.onRealtimeMarkerClick(v, false)
            this.$refs.arcgisMonitorMapRef.mapCenterAt(v.gis.realtimeMarker.geometry)
          }
        }
      },

      /**
       * 初始化显示
       */
      initDisplay () {
        // 初始化分屏显示
        let leftPercent = 1 - (230 / this.$refs.splitWidth.$el.clientWidth)
        this.offset = leftPercent
        // 初始化订阅树显示
        // this.treeStyle.height = (this.$refs.splitWidth.$slots.right[0].elm.clientHeight - 55) + 'px'

        this.onVehicleInfoSplitMoveEnd()
      },

      /**
       * 实时车辆数据深拷贝
       */
      // realtimeVehicleInfoDataDeepCopy(realtimeVehicleInfo) {
      //   return {
      //     id: realtimeVehicleInfo.id,
      //     terminalNum: realtimeVehicleInfo.terminalNum,
      //     registrationNum: realtimeVehicleInfo.registrationNum,
      //     registrationColor: realtimeVehicleInfo.registrationColor,
      //     speed: realtimeVehicleInfo.speed,
      //     direction: realtimeVehicleInfo.direction,
      //     gpsDatetime: realtimeVehicleInfo.gpsDatetime,
      //     recvDatetime: realtimeVehicleInfo.recvDatetime,
      //     state: realtimeVehicleInfo.state,
      //     address: realtimeVehicleInfo.address,
      //     addressEx: realtimeVehicleInfo.addressEx
      //   }
      // },

      /**
       * 创建统计任务
       */
      createCalculateTask () {
        this.calculateTaskTimer = setInterval(() => {
          this.vehicleDymaicManager.calculate()
          this.$refs.vehicleDymaicInfoTableRef.updateRealtimeVehicleInfoTable()
        }, 2000)
      },

      /**
       * 销毁统计任务
       */
      destoryCalculateTask () {
        if (this.calculateTaskTimer) {
          clearInterval(this.calculateTaskTimer)
          this.calculateTaskTimer = null
        }
      },

      /**
       * 封装车牌颜色底色方法
       */
      registrationColorCompute (val) {
        return registrationColor(val)
      },

      /**
       * 封装车牌颜色文字颜色方法
       */
      registrationTextColorCompute (val) {
        return registrationTextColor(val)
      },

      /**
       * 筛选关键字列表
       */
      vehicleListDataMethod () {
        if (this.vehicleListData) {
          if (this.searchVehicleListDataKeyword && this.searchVehicleListDataKeyword !== '') {
            return this.vehicleListData.filter(item => {
              if (item.customName) {
                if (item.customName.toLocaleUpperCase().indexOf(this.searchVehicleListDataKeyword.toLocaleUpperCase()) >= 0) {
                  return true
                }
              }
              let name = null
              if (item.registrationNum) {
                name = item.registrationNum
              } else {
                name = item.vin
              }
              if (name.toLocaleUpperCase().indexOf(this.searchVehicleListDataKeyword.toLocaleUpperCase()) >= 0) {
                return true
              } else {
                return false
              }
            })
          } else {
            return this.vehicleListData
          }
        } else {
          return []
        }
      },

      /**
       * 保存订阅列表缓存
       */
      saveRealtimeMonitorSubscribe () {
        // 保存订阅列表缓存
        if (!this.vehicleDymaicManager.subscribedVehicleInfos) {
          return
        }
        let list = []
        this.vehicleDymaicManager.subscribedVehicleInfos.forEach(item => {
          let v = {
            id: item.id,
            registrationNum: item.registrationNum,
            registrationColor: item.registrationColor,
            vin: item.vin,
            customName: item.customName,
            positioningDeviceInfos: []
          }
          if (item.positioningDeviceInfos && item.positioningDeviceInfos.length > 0) {
            item.positioningDeviceInfos.forEach(p => {
              v.positioningDeviceInfos.push({
                id: p.id,
                terminalNum: p.terminalNum
              })
            })
          }
          list.push(v)
        })
        store.dispatch('RealtimeMonitorSubscribeServ_SaveRealtimeMonitorSubscribe', {
          params: { subscribeList: JSON.stringify(list) },
          urlparams: null
        }).then(() => {
          console.log('保存订阅列表缓存成功')
        }).catch(err => {
          this.$Message.error(err)
          console.log(err)
        })
      },

      /**
       * 接收实时定位数据回调
       */
      onRecvDymaicDataCallback (realtimeLocationFrame) {
        this.$refs.arcgisMonitorMapRef.putVehicleMarker(realtimeLocationFrame)
        let vehicleInfo = this.vehicleDymaicManager.findVehicleInfoByTerminalNum(realtimeLocationFrame.terminalNum)
        if (vehicleInfo.info) {
          this.$refs.vehicleDymaicInfoTableRef.updateRealtimeVehicleInfoCache(vehicleInfo)
        }
      },

      /**
       * 取消监控车辆回调
       */
      onCancelSubscribeDymaicDataCallback (vehicleInfos) {
        this.$refs.arcgisMonitorMapRef.removeVehicleMarker(vehicleInfos)
        vehicleInfos.forEach(item => {
          this.$refs.vehicleDymaicInfoTableRef.removeRealtimeVehicleInfoCache(item)
        })
      },

      /**
       * 地图选中车辆改变回调
       */
      onCurrentClickedVehicleInfoChange (vehicleInfo) {
        this.currentClickedVehicleInfo = vehicleInfo
      },

      /**
       * 动态车辆列表点解车辆名称回调
       */
      onVehicleNameClick (params) {
        let vehicleInfo = this.vehicleDymaicManager.findVehicleInfoByTerminalNum(params.mainKey)
        if (vehicleInfo) {
          if (this.lastvehicleInfo != vehicleInfo) {
            this.$refs.arcgisMonitorMapRef.unSelectVehicle()
          }
          this.$refs.arcgisMonitorMapRef.onCloseVehicleInfoWindow()
          this.$refs.arcgisMonitorMapRef.onRealtimeMarkerClick(vehicleInfo, false)
          this.$refs.arcgisMonitorMapRef.mapCenterAt(vehicleInfo.gis.realtimeMarker.geometry)
          this.lastvehicleInfo = vehicleInfo
        }
      },
      /**
       * 点击tree车辆列表名称回调
       */
      onvehicleinfo (e) {
        console.log(e)
        if (e) {
          let vehicleInfo = this.vehicleDymaicManager.findVehicleInfoByTerminalNum(e.terminalNum)
          if (vehicleInfo) {
            if (this.lastvehicleInfo != vehicleInfo) {
              this.$refs.arcgisMonitorMapRef.unSelectVehicle()
            }
            this.$refs.arcgisMonitorMapRef.onCloseVehicleInfoWindow()
            this.$refs.arcgisMonitorMapRef.onRealtimeMarkerClick(vehicleInfo, false)
            this.$refs.arcgisMonitorMapRef.mapCenterAt(vehicleInfo.gis.realtimeMarker.geometry)
            this.lastvehicleInfo = vehicleInfo
          }
        }
      },

      /**
       * 加载直接绑定账号车辆
       */
      onLoadDirectlyUnderBindVehicleInfos () {
        this.vehicleListLoadding = true
        store.dispatch('VehicleInfoServ_GetDirectlyUnderBindAll', {
          params: null,
          urlparams: null
        }).then(() => {
          console.log(store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult)
          this.vehicleDymaicManager.putVehicleInfo(store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult)
          this.vehicleListData = this.makeSelectTableDataItem(store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult)
          this.vehicleListLoadding = false
        }).catch(err => {
          this.vehicleListLoadding = false
          this.$Message.error(err)
          console.log(err)
        })
      },

      /**
       * 加载所有车辆
       */
      onLoadAllVehicleInfos () {
        this.vehicleListLoadding = true
        store.dispatch('VehicleInfoServ_GetBindAll', {
          params: null,
          urlparams: null
        }).then(() => {
          this.vehicleDymaicManager.putVehicleInfo(store.getters.get_VehicleInfo_GetBindAllResult)
          this.vehicleListData = this.makeSelectTableDataItem(store.getters.get_VehicleInfo_GetBindAllResult)
          this.vehicleListLoadding = false
        }).catch(err => {
          this.vehicleListLoadding = false
          this.$Message.error(err)
          console.log(err)
        })
      },

      /**
       * 按车辆信息分组id加载车辆列表
       * @param groupId
       */
      onLoadVehicleInfosByGroupId (groupId) {
        this.vehicleListLoadding = true
        store.dispatch('VehicleInfoServ_GetGroupRecursiveAll', {
          params: { groupId: groupId },
          urlparams: null
        }).then(() => {
          this.vehicleDymaicManager.putVehicleInfo(store.getters.get_VehicleInfo_GetGroupRecursiveAllResult)
          this.vehicleListData = this.makeSelectTableDataItem(store.getters.get_VehicleInfo_GetGroupRecursiveAllResult)
          this.vehicleListLoadding = false
        }).catch(err => {
          this.vehicleListLoadding = false
          this.$Message.error(err)
          console.log(err)
        })
      },
      onDownloadTable () {
        // 导出的方法

        require.ensure([], () => {
          // 设置Excel的表格第一行的标题
          const tHeader = ['车牌号', '车牌颜色', '行驶速度', '方向', '定位时间', '运行状态', '持续时长', '状态', '报警', '位置']
          //  'date', 'struct1', 'struct2'对象的属性
          const filterVal = ['1', '10', '2', '3', '4', '5', '6', '7', '8', '9']

          // 数据集
          // const list = this.datalist;
          const list = this.$refs.vehicleDymaicInfoTableRef.bigDataTableDataHandled
          let result = []
          result = JSON.parse(JSON.stringify(list))
          for (let i = 0; i < result.length; i++) {
            result[i].push(list[i].registrationColor)
            for (let j = 0; j < result[i].length; j++) {
              if (j == 2) {
                result[i][j] = result[i][j] / 10 + 'Km/h'
              }
              if (j == 3) {
                result[i][j] = explainDirection(result[i][j])
              }
              if (j == 4) {
                result[i][j] = new Date(result[i][j]).Format('yyyy年MM月dd日 hh:mm:ss')
              }
              if (j == 7) {
                result[i][j] = explainState(result[i][j])
              }
              if (j == 8) {
                result[i][j] = explainAlarmSign(result[i][j])
              }
              if (j == 10) {
                result[i][j] = result[i][j] === 1 ? '蓝色' : result[i][j] === 2 ? '黄色' : result[i][j] === 3 ? '黑色' : result[i][j] === 4 ? '白色' : '灰色'
              }
            }
          }

          const data = this.formatJson(filterVal, result)
          // excel名称可自定义
          const excelName = '车辆定位数据' + new Date().Format('yyyy年MM月dd日 hh-mm-ss')
          export_json_to_excel(tHeader, data, excelName)
        })
      },
      // 格式化json
      formatJson (filterVal, jsonData) {
        return jsonData.map(v =>
          filterVal.map(j => v[j])
        )
      },
      onMinimum () {
        this.offsetVertical = 0.95

        // 调整实时数据列表
        this.vehicleDymaicInfoTableHeight = (this.$refs.splitV.$slots.bottom[0].elm.clientHeight - 30)
        let that = this
        setTimeout(function () {
          that.vehicleDymaicInfoTableHeight = (that.$refs.splitV.$slots.bottom[0].elm.clientHeight - 30)
        }, 5)
      },
      onMaximize () {
        this.offsetVertical = 0.05

        // 调整实时数据列表
        this.vehicleDymaicInfoTableHeight = (this.$refs.splitV.$slots.bottom[0].elm.clientHeight - 30)
        let that = this
        setTimeout(function () {
          that.vehicleDymaicInfoTableHeight = (that.$refs.splitV.$slots.bottom[0].elm.clientHeight - 30)
        }, 5)
      },
      onOriginalState () {
        this.offsetVertical = this.lastoffsetVertical

        // 调整实时数据列表
        this.vehicleDymaicInfoTableHeight = (this.$refs.splitV.$slots.bottom[0].elm.clientHeight - 30)
        let that = this
        setTimeout(function () {
          that.vehicleDymaicInfoTableHeight = (that.$refs.splitV.$slots.bottom[0].elm.clientHeight - 30)
        }, 5)
      }
    },
    computed: {
      allCount () {
        if (this.vehicleDymaicManager) {
          let allCount = this.vehicleDymaicManager.runCount + this.vehicleDymaicManager.stopCount + this.vehicleDymaicManager.alarmCount
          return allCount
        } else {
          return 0
        }
      },
      runCount () {
        if (this.vehicleDymaicManager) {
          return this.vehicleDymaicManager.runCount
        } else {
          return 0
        }
      },
      stopCount () {
        if (this.vehicleDymaicManager) {
          console.log(this.vehicleDymaicManager)
          return this.vehicleDymaicManager.stopCount
        } else {
          return 0
        }
      },
      alarmCount () {
        if (this.vehicleDymaicManager) {
          return this.vehicleDymaicManager.alarmCount
        } else {
          return 0
        }
      },
      vehicleListDataCompute () {
        return this.vehicleListDataMethod()
      }
    },
    beforeDestroy () {
      if (this.vehicleDymaicManager) {
        this.vehicleDymaicManager.onRecvDymaicDataCallback = null
        this.vehicleDymaicManager.onCancelSubscribeDymaicDataCallback = null
        this.vehicleDymaicManager.destroy()
      }
      this.destoryCalculateTask()
    },
    mounted () {
      this.$nextTick(() => {
        setTimeout(() => {
          // 初始化显示
          this.initDisplay()
          // 加载客户自定义POI点
          // this.loadCustomPOIs()
          // 创建统计任务
          this.createCalculateTask()
        }, 200)

        window.onresize = () => {
          this.onVehicleInfoSplitMoveEnd()
        }
        // console.log(window.location.protocol + '//' + window.location.host)

        if (!this.vehicleDymaicManager) {
          console.log('创建vehicleDymaicManager')
          this.vehicleDymaicManager = new VehicleDymaicManager()
          this.vehicleDymaicManager.onRecvDymaicDataCallback = this.onRecvDymaicDataCallback
          this.vehicleDymaicManager.onCancelSubscribeDymaicDataCallback = this.onCancelSubscribeDymaicDataCallback
        }

        // 获取订阅列表缓存
        store.dispatch('RealtimeMonitorSubscribeServ_GetMyDetail', {
          params: null,
          urlparams: null
        }).then(() => {
          let r = store.getters.get_RealtimeMonitorSubscribe_GetMyDetailResult
          if (r && r.subscribeList) {
            let vehicleInfos = JSON.parse(r.subscribeList)
            if (vehicleInfos && vehicleInfos.length > 0) {
              this.$Modal.confirm({
                title: '提示',
                content: '是否加载上次监控的车辆',
                okText: '是',
                cancelText: '否',
                onOk: () => {
                  this.vehicleDymaicManager.putVehicleInfo(vehicleInfos)
                  this.vehicleDymaicManager.subscribeDymaicData(vehicleInfos, true)
                },
                onCancel: () => {
                }
              })
            }
          }
        }).catch(err => {
          this.$Message.error(err)
          console.log(err)
        })
      })
    }
  }
</script>
<style lang="less">

  .center-middle {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .split-pane-page-wrapper {
    height: 100%;

    .pane {
      width: 100%;
      height: 100%;

      &.left-pane {
        background: #ccc;
      }

      &.right-pane {
        background: #ccc;
      }

      &.top-pane {
        background: white;
      }

      &.bottom-pane {
        background: #ccc;
      }
    }

    .custom-trigger {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: #000000;
      position: absolute;
      .center-middle;
      box-shadow: 0 0 6px 0 rgba(28, 36, 56, 0.4);

      i.trigger-icon {
        .center-middle;
      }
    }

  }

</style>
